<template>
    <div class="container">
        <b-button type="is-primary" class="is-rounded" @click="show = !show">+</b-button>
        <form v-show="show">
            <div class="field">
                <b-field label="Type">
                    <b-select placeholder="Select type" v-model="typeSelected" required>
                        <option v-for="(type, index) in types" :value="type" :key="index">{{ type }}</option>
                    </b-select>
                </b-field>

                <b-field label="Date">
                    <b-datetimepicker
                        id="datepicker"
                        v-model="selected"
                        required
                        rounded
                        placeholder="Click to select..."
                        :locale="locale"
                        :first-day-of-week="firstDayOfWeek"
                        :datepicker="{ showWeekNumber }"
                        :timepicker="{ enableSeconds, hourFormat }"
                    ></b-datetimepicker>
                </b-field>
            </div>
            <b-button type="is-primary" @click="submitEvent">Submit</b-button>
        </form>
    </div>
</template>

<script>
import addLogs from '../helpers/fireBaseAdd'
import db from '../fireBaseInit'

export default {
    props: ['eventList'],
    data() {
        return {
            show: false,
            types: ['Feed', 'Solid', 'Liquid'],
            typeSelected: '',
            selected: new Date(),
            showWeekNumber: false,
            enableSeconds: false,
            hourFormat: undefined, // Browser locale
            locale: undefined, // Browser locale
            firstDayOfWeek: undefined, // 0 - Sunday
        }
    },
    methods: {
        submitEvent(event) {
            event.preventDefault()
            let ev = {
                'type': this.typeSelected,
                'timestamp': this.selected
            }
            this.eventList.push(ev)
            addLogs(db, ev)
            this.show = false
        }

    }

}
</script>

<style scoped>
#datepicker {
    width: 50%;
    text-align: center !important
}
</style>